import { store } from '@/main'

export const MyHotspotShift = {
  inserted: (el) => {
    if (store.state.device > 0) {
      let height = el.clientHeight
      let shift = (height / 2) * -1
      el.style.transform = 'translateY(' + shift + 'px)'
    }
  }
}



// WEBPACK FOOTER //
// ./src/directives/my-hotspot-shift.js